import { createGlobalStyle } from 'styled-components';
import get from 'lodash/get';
import curry from 'lodash/curry';
import { colors } from '@omilia/theme';

import logo from './encodedImage';
import bubbleImage from './encodedBubbleImage';

createGlobalStyle`
body {
  @import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
}
`;

export interface ITheme {
  primaryColor?: string;
  logoUrl?: string;
  logoAlt?: string;
  logoBorder?: boolean;
  fontFamily?: string;
  title?: string;
  bubbleUrl?: string;
  bubbleAlt?: string;
}

const baseTheme: ITheme = {
  primaryColor: colors.COLOR_DEEP_PURPLE_800,
  logoUrl: logo,
  logoAlt: ' ',
  logoBorder: true,
  fontFamily: `Montserrat, sans-serif`,
  title: 'Omilia Chat',
  bubbleUrl: bubbleImage,
  bubbleAlt: 'Bubble alt',
};

export default baseTheme;

/**
 * Shallowly mix a theme with the base one.
 */
export const makeTheme: (theme: ITheme) => ITheme = theme => ({
  ...baseTheme,
  ...theme,
});

/**
 * Extract theme props with confidence
 */
export const getThemeProp = curry((key: string, props: any) =>
  get(props, `theme.${key}`, get(baseTheme, key)),
);
